import { useState } from "react";
import { Form } from "antd";

import { type ScheduledAiAgentMessageAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";
import { type ProgramAutomationScheduledTask } from "@fitness-app/data-models/entities/ProgramAutomation";

import { type AiAgentMessageTaskFormModel } from "./types";

// scheduleTiming lives on the ProgramAutomationScheduledTask wrapper, so keep it
// on the edited task to preload the package-anchor fields (TRE-1612).
type EditedAiAgentMessageTask = ScheduledAiAgentMessageAutomation &
  Pick<ProgramAutomationScheduledTask, "scheduleTiming">;

export const useAiAgentMessageTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<AiAgentMessageTaskFormModel>();
  const [editedTask, setTask] = useState<null | EditedAiAgentMessageTask>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: EditedAiAgentMessageTask) => {
    if (task) {
      setTask(task);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
